import React, { useState, useEffect } from 'react';

interface TypewriterProps {
  texts: string[];
  typingSpeed?: number;
  erasingSpeed?: number;
  delayBeforeErase?: number;
  delayBetweenTexts?: number;
}

export const Typewriter: React.FC<TypewriterProps> = ({
  texts,
  typingSpeed = 150,
  erasingSpeed = 100,
  delayBeforeErase = 2000,
  delayBetweenTexts = 1000,
}) => {
  const [textIndex, setTextIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    const currentText = texts[textIndex];

    if (isTyping) {
      if (displayedText.length < currentText.length) {
        timeout = setTimeout(() => {
          setDisplayedText(currentText.substring(0, displayedText.length + 1));
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, delayBeforeErase);
      }
    } else {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText(currentText.substring(0, displayedText.length - 1));
        }, erasingSpeed);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(true);
          setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        }, delayBetweenTexts);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isTyping, textIndex, texts, typingSpeed, erasingSpeed, delayBeforeErase, delayBetweenTexts]);

  return (
    <span>{displayedText}</span>
  );
};
